import { motion } from "framer-motion";
import { UserCog, Brain, Baby } from "lucide-react";
import { SectionHeading } from "./SectionHeading";

const team = [
  {
    image:
      "https://customer-assets.emergentagent.com/job_saude-decisoes/artifacts/4ak5bnv7_enfermeira.png",
    role: "Enfermeiros avaliadores e auditores",
    desc: "Condução das entrevistas e análise técnica das informações.",
    icon: UserCog,
    accent: "#3532B3",
  },
  {
    image:
      "https://customer-assets.emergentagent.com/job_saude-decisoes/artifacts/v8f0yt9e_psicologa.png",
    role: "Psicólogo especialista",
    desc: "Apoio em casos complexos ligados a terapias especiais, saúde mental e patologias neurológicas.",
    icon: Brain,
    accent: "#3787F5",
  },
  {
    image:
      "https://customer-assets.emergentagent.com/job_saude-decisoes/artifacts/2ztkl1fg_medic-kids.png",
    role: "Médico pediatra",
    desc: "Avaliação de casos congênitos, genéticos, síndromes, malformações e situações de alto impacto.",
    icon: Baby,
    accent: "#12DDB5",
  },
];

export const Team = () => {
  return (
    <section
      id="equipe"
      data-testid="team-section"
      className="relative py-20 md:py-28 bg-[#F6F8FB]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <SectionHeading
          overline="Equipe"
          title="Equipe multidisciplinar para casos"
          highlight="simples e complexos"
          subtitle="Avaliação operacional, especialização clínica e validação técnica."
          testid="team-heading"
        />

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {team.map((t, idx) => (
            <motion.article
              key={t.role}
              data-testid={`team-card-${idx}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{
                duration: 0.6,
                ease: [0.16, 1, 0.3, 1],
                delay: idx * 0.08,
              }}
              whileHover={{ y: -6 }}
              className="group bg-white rounded-3xl border border-[#E5EAF2] overflow-hidden shadow-[0_8px_30px_rgba(15,23,42,0.04)] hover:shadow-[0_24px_60px_rgba(53,50,179,0.12)] transition-all duration-300"
            >
              <div className="relative aspect-[5/4] overflow-hidden">
                <img
                  src={t.image}
                  alt={`${t.role} da equipe Previsa Saúde`}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1F2937]/35 to-transparent" />
                <div
                  className="absolute top-4 left-4 w-11 h-11 rounded-2xl flex items-center justify-center backdrop-blur-md border border-white/30"
                  style={{
                    backgroundColor: `${t.accent}cc`,
                    color: "#fff",
                  }}
                >
                  <t.icon size={20} strokeWidth={1.8} />
                </div>
              </div>
              <div className="p-7">
                <h3 className="text-lg font-bold text-[#1F2937]">{t.role}</h3>
                <p className="mt-3 text-[#64748B] leading-relaxed text-[15px]">
                  {t.desc}
                </p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
